import CallJSS from "@/Core/Bridge/CallJSS";
import {confJson} from "@/app/config/confJson";
import {KitConst} from "@/Fwk/Kit/KitConst";
import Util from "@/Master/Util";
import ChannelMgr from "@/Fwk/Channel/ChannelMgr";
import UtilBrowser from "@/Master/UtilBrowser";
import DuMgr from "@/Fwk/SM/DuMgr";
import {JsonData} from "@/Fwk/Kit/JsonData";
import GoogleTrack from "@/Fwk/Kit/GoogleTrack";
import {getUserId} from "@/app/utils/auth";

export class WebPlatform implements IPlatform {

    constructor() {
        CallJSS.GameInit()
    }

    public GetUserId(): number {
        return getUserId();
    }

    public GetCfg(): string {
        return JSON.stringify(confJson);
    }

    public GetDeviceIpAddress(): string {
        return "0";
    }

    public isVpnConnected(): boolean {
        return false;
    }

    public isWifiProxy(): boolean {
        return false;
    }

    public IsNetworkOk(): boolean {
        return navigator.onLine;
    }

    public GetNetworkType(): string {
        // @ts-ignore
        const connection = navigator.connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
        if (connection) {
            return connection.effectiveType || 'unknown';
        } else {
            return 'unknown';
        }
    }

    public GetTestConfig(): string {
        const isTest = this.IsTestProduct();
        const isLog = Util.isLog;
        const json = new JsonData();
        json.put("log", isLog);
        json.put("unitylog", isLog);
        json.put("testmode", isTest);
        json.put("adtest", isTest);
        json.put("test210", isTest);
        return json.toString()
    }


    public GetVersionName(): string {
        return confJson.h5_version_name
    }

    public GetVersionCode(): number {
        return confJson.h5_version_code
        // return confJson.h5_host_name
    }

    //todo 广告ID 归因ID
    public GetGAID(): string {
        return ChannelMgr.getWebGAID;
    }

    public GetAppLabel(): string {
        return confJson.h5_app_name;
    }

    public GetPackageName(): string {
        return confJson.h5_package_name;
    }

    public GetCountryCode(): string {
        return UtilBrowser.getSystemCountry;
    }

    public GetLanguage(): string {
        return UtilBrowser.getLanguage;
    }

    public GetOsVersion(): string {
        return UtilBrowser.getOsVersion;
    }

    public GetOsBrand(): string {
        return UtilBrowser.getBrowserName;//获取浏览器类型
    }

    public GetOsModel(): string {
        return `os:${UtilBrowser.getOsName} osV:${UtilBrowser.getOsVersion} br:${UtilBrowser.getBrowserName} brV:${UtilBrowser.getBrowserVersion}`;
    }

    public GetSMID(): string {
        return "";
    }

    public GoogleGTMEvent(name: string, jsonStr: string) {
        let json = {};
        try {
            json = JSON.parse(jsonStr);
        }
        catch (e) {
            console.error('GoogleGTM GoogleGTMEvent', name, jsonStr)
        }
        GoogleTrack.pushGTMEvent(name, json);
    }

    public InitShuzilmSDK(appKey: string) {

    }

    public QuerySmID(action: (id: string) => void): void {
        const id = DuMgr.SMID;
        action(id);
    }

    public StoreClipboard(text: string) {

    }


    public isRoot(): boolean {
        return false;
    }

    public IsTestProduct(): boolean {
        return Util.isTestMode;
    }

    public isSimulator(): boolean {
        return false;
    }


    public Jump(key: string, strValue: string): boolean {
        if (key === KitConst.URL) {
            return true;
        }

        return false;
    }

    public InitForterSDK(forterId: string) {
    }

    public SetForterUserID(userId: string) {

    }

    public GetForterJSCode() {
        return "";
    }

}
